import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiRouteConfig} from '../../../../config/api.route.config';
import {Observable} from 'rxjs';
import {AuthenticationResponse} from '../../model/authenticationResponse';
import {ApplicationType, BuildingProductType} from '../../enums/enums';
import {TokenService} from '../token.service';
import {CookieService} from 'ngx-cookie-service';
import {Environment} from "../../../../environment/environment";

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {

  public get TOKEN_TAG() {
    return `jwt_${this.environment.environmentName}`;
  }

  public get REFRESH_TOKEN_TAG() {
    return `jwt_refresh_token_${this.environment.environmentName}`;
  }

  constructor(
      private httpClient: HttpClient,
      private config: ApiRouteConfig,
      private tokenService: TokenService,
      private cookieService: CookieService,
      private readonly environment: Environment,
  ) {
  }

  public refreshTokensIfNeeded() {
    if (!this.isUserLoggedIn() || this.tokenService.getToken() !== this.getToken()) {
      this.setTokens();
    }
  }

  public isUserLoggedIn(): boolean {
    return this.doesTokenExist();
  }

  public doLoginUsingMagicLinkToken(token: string): Observable<AuthenticationResponse> {
    return this.httpClient.post<AuthenticationResponse>(this.config.getRouteWithInjectedParams(this.config.LOGIN_MAGIC_LINK_TOKEN, [token]), null);
  }

  public doesUserHaveActiveSubscription(): boolean {
    const businessProducts = this.tokenService.getBusinessProducts();
    return businessProducts.includes(BuildingProductType.PROSUBSCRIPTION)
      || businessProducts.includes(BuildingProductType.PREMIUMSUBSCRIPTION)
      || businessProducts.includes(BuildingProductType.DEMOSUBSCRIPTION)
      || businessProducts.includes(BuildingProductType.LITESUBSCRIPTION);
  }

  public doesUserHaveBuildingAccount(): boolean {
    const applications: ApplicationType[] = this.tokenService.getApplications();
    return applications.some(app => app === ApplicationType.BUILDING);
  }

  public setTokens() {
    this.tokenService.setToken(this.getToken());
    this.tokenService.setRefreshToken(this.getRefreshToken());
  }

  public getRefreshToken(): string {
    return this.cookieService.get(this.REFRESH_TOKEN_TAG);
  }

  public getToken(): any {
    const token = this.cookieService.get(this.TOKEN_TAG);
    return (token == null || token === '') ? null : token;
  }

  public doesTokenExist(): boolean {
    return this.cookieService.check(this.TOKEN_TAG);
  }
}
